module.exports = __webpack_public_path__ + "img/4.47ca905b.jpg";